exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{margin:0;padding:0;box-sizing:border-box}body,html{font:12px/1.5 system ui;font-family:Microsoft YaHei,微软雅黑,Helvetica Neue,Helvetica,Hiragino Sans GB,Arial,sans-serif;font-family:var(--font-family);height:100%;background-color:#fff;color:#333;color:var(--color-font-1)}input,textarea{font-family:Microsoft YaHei,微软雅黑,Helvetica Neue,Helvetica,Hiragino Sans GB,Arial,sans-serif;font-family:var(--font-family)}li{list-style:none}img{max-width:100%}a{text-decoration:none;color:#1c6da3;color:var(--color-link)}", ""]);

// exports
